// Trailmap L2 Drip 3 — small chrome primitives for an expanded artifact tile:
// a loading shimmer, a content-load-failed affordance, a raw-text fallback,
// and an error boundary that catches a throwing viewer. All dark-mode aware
// ([[feedback_dark_mode_parity_first_class]]). No api-reaching imports → safe
// in CRA-jest.
import React from 'react';
import type { Artifact } from '../../../../types/artifact';

export const Shimmer: React.FC = () => (
  <div data-testid="tile-shimmer" className="h-full w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
);

export const ContentLoadFailed: React.FC<{ artifact: { name?: string } }> = ({ artifact }) => (
  <div className="p-3 text-sm text-red-700 dark:text-red-300">
    Could not load {artifact?.name ?? 'artifact'}.
  </div>
);

export const RawTextDump: React.FC<{ artifact: Pick<Artifact, 'content'> }> = ({ artifact }) => (
  <pre className="p-3 text-xs overflow-auto text-gray-800 dark:text-gray-100 whitespace-pre-wrap">
    {typeof artifact?.content === 'string' ? artifact.content : JSON.stringify(artifact?.content ?? '', null, 2)}
  </pre>
);

interface EBProps { fallback: React.ReactNode; children: React.ReactNode; }
export class ArtifactTileErrorBoundary extends React.Component<EBProps, { failed: boolean }> {
  constructor(p: EBProps) { super(p); this.state = { failed: false }; }
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}
